/* eslint-disable no-multi-str */
import React, { useState } from "react";
import Carousel, { slidesToShowPlugin } from "@brainhubeu/react-carousel";
import { Modal, Row, Col } from "antd";
import "@brainhubeu/react-carousel/lib/style.css";
import "./CarouselPreguntasFrecuentes.css";

export const Preguntas = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [numeroPreguntaModal, setNumeroPreguntaModal] = useState("");
  const [valorCarrusel, setValorCarrusel] = useState(0);
  const [preguntaModal, setPreguntaModal] = useState("");
  const [respuestaModal, setRespuestaModal] = useState("");

  const openModal = (numero, pregunta, respuesta) => {
    setIsModalVisible(true);
    setNumeroPreguntaModal(numero);
    setPreguntaModal(pregunta);
    setRespuestaModal(respuesta);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const onChange = (value) => {
    if (getWindowDimensions().width > 800) {
      if (value > valorCarrusel) {
        if (valorCarrusel + 3 > arrayPeguntas.length - 1) {
          setValorCarrusel(valorCarrusel + 2);
        } else {
          setValorCarrusel(valorCarrusel + 3);
        }
      } else if (value < valorCarrusel) {
        if (valorCarrusel === arrayPeguntas.length - 1) {
          setValorCarrusel(valorCarrusel - 2);
        } else {
          setValorCarrusel(valorCarrusel - 3);
        }
      }
    } else {
      setValorCarrusel(value);
    }
  };

  const hasWindow = typeof window !== "undefined";
  const getWindowDimensions = () => {
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
      width,
      height,
    };
  };

  let arrayPeguntas = [
    {
      pregunta:
        "¿Debo realizar el registro si ya había participado en alguna otra convocatoria del sistema INE u OPLE?",
      respuesta:
        "Si realizaste registro en la convocatoria del Concurso Público 2022-2023 del sistema INE, no será necesario, sin embargo, puedes actualizar tus datos personales, académicos, experiencia laboral y tipo de aspirante en el periodo correspondiente.",
    },
    {
      pregunta: "¿Qué es el registro y postulación de aspirantes?",
      respuesta:
        "Es el proceso mediante el cual las personas interesadas en participar en el Concurso Público se registran e inscriben a este, y proporcionan la información que les sea requerida para participar conforme la Convocatoria y lo estipulado en el Subsistema del Concurso Público.",
    },
    {
      pregunta: "Si no me alcanzo a registrar y postular, ¿existe prórroga?",
      respuesta:
        "A fin de que las condiciones sean igualitarias no habrá prórroga de ningún tipo, para ninguna persona.",
    },
    {
      pregunta:
        "¿Me puedo registrar y postular cualquier día, en cualquier momento?",
      respuesta:
        "Sí, el registro y postulación es en línea, por medio de la Internet, y puede realizarlo en los días establecidos en la Convocatoria correspondiente.",
    },
    {
      "pregunta":"¿Por cuántos cargos o puestos puedo concursar en esta Convocatoria?",
      "respuesta": "Cada persona aspirante podrá concursar o postularse por un solo cargo o puesto."
    },
    {
      pregunta:
        "¿Qué sucede si se cierra el registro antes de que me inscriba, puedo hacerlo posteriormente?",
      respuesta:
        "No, una vez concluido el periodo de registro no podrá inscribirse. Las fechas establecidas para el registro e inscripción son inalterables.",
    },
    {
       "pregunta":"¿Habrá quien me asesore en el registro?",
      "respuesta": '\
      Es conveniente que revise primero la guía de usuario, en caso de que persista su duda puede solicitar atención de las 9:00 a las 18:00 horas (tiempo del centro), a través de los siguientes medios:\
      <br/><br/>\
      <b>INETEL</b> a través del número telefónico <b><a href ="tel:+8004332000">800 433 2000</a></b>.\
      <br /><br/>\
      La Dirección Ejecutiva del Servicio Profesional Electoral Nacional (DESPEN) a través del número telefónico <b><a href ="tel:+5556284200">(55) 5628-4200</a></b> extensiones:\
      <br />\
      <b>372521 / 373014 / 373146 / 373302 / 373304 / 373318</b>'
    },
    {
      pregunta:
        "¿Qué requerimientos técnicos debe tener el equipo donde realice el registro y postulación?",
      respuesta:
        '\
        La computadora debe tener las características técnicas siguientes:\
        <br /> Requisitos técnicos \
          <ul> \
            <li>macOS® de Apple® 10.9 y superiores</li> \
            <li>Microsoft® Windows® 7 y superiores</li> \
            <li>Chrome OS</li>\
            <li>Ubuntu® y otras distribuciones de Linux®</li>\
            <li>Android 4.4 y superiores</li>\
            <li>iOS® 12 y superiores</li>\
          </ul> \
          <br />En cuanto al navegador, cualquiera de los siguientes navegadores modernos:\
          <ul>\
            <li>Navegador Chrome (versión 50 y superiores) <a href="https://www.google.com/chrome/" target="_blank"> Descargar la versión más reciente</a></li>\
            <li>Mozilla Firefox (versión 30 y superiores) <a href="https://www.mozilla.org/es-ES/firefox/new/" target="_blank"> Descargar la versión más reciente</a></li>\
            <li>Microsoft Edge <a href="https://www.microsoft.com/es-es/edge" target="_blank"> Descargar la versión más reciente</a> (con Microsoft Internet Explorer® 10 y 11 tiene una compatibilidad limitada)</li>\
            <li>Safari de Apple <a href="https://support.apple.com/es_ES/downloads/safari" target="_blank"> Descargar la versión más reciente</a></li>\
            <li>Opera <a href="https://www.opera.com/es/download" target="_blank"> Descargar la versión más reciente</a></li>\
          </ul>\
          Nota: Para visualizar los documentos en PDF es necesario que habilites Adobe Acrobat Reader.',
    },

    {
      pregunta:
        "¿Tengo que entregar algún documento para registrarme y postularme?, ¿Dónde los entrego?",
      respuesta:
        "En la etapa de registro y postulación subirá su título o cédula profesional en formato PDF. Además, deberá capturar la información solicitada en el registro.",
    },
    {
      pregunta:
        "¿Puedo decidir en qué entidad federativa llevar a cabo las etapas presenciales del Concurso?",
      respuesta: "Sí, en el registro seleccionará donde realizar estas etapas.",
    },
    {
      pregunta: "Ya me registré, ¿cuál es el siguiente paso?",
      respuesta:
        " Después de registrarse deberá seleccionar el cargo o puesto por el que desea concursar, a través del proceso de postulación, de acuerdo con sus intereses, formación académica y experiencia profesional.",
    },
    {
      pregunta: "¿Puedo cancelar mi postulación?",
      respuesta:
        " Si no confirma su asistencia al examen de conocimientos, su participación en el Concurso queda suspendida automáticamente, por lo que no hay necesidad de hacer algún otro trámite.",
    },
    {
      pregunta: "¿Cómo obtengo mi folio de participación?",
      respuesta:
        "Lo obtendrá después de que confirme su participación en el examen de conocimientos.",
    },
    {
      "pregunta":"Me registré, pero no me postulé, ¿qué puedo hacer?",
      "respuesta": "La postulación es un requisito indispensable para participar y se realiza en la etapa de registro, después del periodo establecido no es posible postularse, por lo que, de ser el caso, no continuará participando en el Concurso."
    }
  ]
  return (
    <div className="card-menu-home">
      <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 10 }}>
        Preguntas frecuentes
      </div>
      <Carousel
        value={valorCarrusel}
        onChange={onChange}
        plugins={[
          "arrows",
          {
            resolve: slidesToShowPlugin,
            options: {
              numberOfSlides: 3,
            },
          },
        ]}
        breakpoints={{
          800: {
            plugins: [
              "arrows",
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 3,
                },
              },
            ],
          },

          799: {
            plugins: [
              "arrows",
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 1,
                },
              },
            ],
          },
        }}
      >
        {arrayPeguntas.map((item, index) => (
          <div className="main-pregunta" key={index}>
            <div className="contenedornumero">
              <div className="numero">{index + 1}</div>
            </div>
            <div className="pregunta">{item.pregunta}</div>
            <div
              className="respuesta"
              dangerouslySetInnerHTML={{
                __html: item.respuesta.slice(0, 130) + "...",
              }}
            ></div>
            <div
              onClick={() => openModal(index, item.pregunta, item.respuesta)}
              className="fieldVerMas"
            >
              Leer más
            </div>
          </div>
        ))}
      </Carousel>

      <Modal
        title="Preguntas frecuentes"
        footer={[]}
        visible={isModalVisible}
        onCancel={closeModal}
      >
        <div>
          <Row>
            <Col span={3}>
              <div className="numero">{numeroPreguntaModal + 1}</div>
            </Col>
            <Col span={21}>
              <p className="pregunta">{preguntaModal}</p>
            </Col>
          </Row>
          <p
            className="respuesta contenedorPreguntaModal"
            dangerouslySetInnerHTML={{ __html: respuestaModal }}
          ></p>
        </div>
      </Modal>
    </div>
  );
};
